import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const cardImages = [
  { id: 1, src: "/ritualCard.png" },
  { id: 2, src: "/ritualCard1.png" },
  { id: 3, src: "/ritualCard2.png" },
];

const RoutinePlan = () => {
  const [cards, setCards] = useState(cardImages);

  useEffect(() => {
    const interval = setInterval(() => {
      setCards((prev) => {
        const [first, ...rest] = prev;
        const nextId = (Math.max(...prev.map((c) => c.id)) % cardImages.length) + 1;
        const nextCard = cardImages[nextId - 1];
        return [...rest, { ...nextCard, id: Date.now() }];
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const ref = useRef(null);

  return (
    <div className="w-full h-full flex justify-center items-center overflow-hidden px-2">
      <div className="relative w-full h-full pt-1 mb-5">
        {/* Заголовок */}
        <div className="flex flex-col items-center w-full">
          <h1 className="text-4xl text-center font-medium 
               bg-gradient-to-r from-[#FC5EB2] via-[#444CE7] to-[#FC5EB2] 
               bg-clip-text text-transparent 
               bg-[length:200%_200%] animate-gradient-x mb-3">
            A beauty routine plan that will lead<br /> you to flawless skin
          </h1>
        </div>

        {/* Контейнер */}
        <div ref={ref} className="relative w-[96%] sm:w-[60%] h-[450px] flex items-center justify-center overflow-hidden mx-auto">
          {/* Фон */}
            <img
            loading="lazy"
              className="absolute w-full h-[450px] rounded-3xl object-cover"
              src="/routineBg.webp"
              alt="Background"
            />

          <AnimatePresence>
            {cards.slice(0, 3).map((card, index) => {
              const zIndex = 100 - index * 10;
              const rotation = [-10, 0, 10][index];
              const scale = [0.9, 0.95, 1][index];
              const yOffset = [20, 10, 0][index];
              
              return (
                <motion.img
                loading="lazy"
                  key={card.id}
                  src={card.src}
                  alt="Routine Item"
                  className="absolute w-[500px] h-auto rounded-lg xss:left-[50px] xs:left-[70px] md:left-1/3 -translate-x-1/2 motion-card"
                  style={{
                    zIndex,
                    top: 70,
                    transformOrigin: "top center",
                    willChange: "transform, opacity"
                  }}
                  initial={{ 
                    opacity: 0, 
                    rotateZ: rotation, 
                    scale,
                    y: 100 // Начальное положение ниже
                  }}
                  animate={{ 
                    opacity: 1, 
                    rotateZ: rotation, 
                    scale,
                    y: 0 // Конечное положение
                  }}
                  exit={{ 
                    opacity: 0, 
                    y: -400, 
                    rotateZ: rotation,
                    scale: 1.1, // Немного увеличиваем при уходе
                    zIndex: 1000 // Устанавливаем максимальный z-index при выходе
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                />
              );
            })}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default RoutinePlan;